import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": true,
      "max-width": "1000"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.lclModel.properties.title) + "\n    "), _c('p', {
          staticClass: "card-description mt-4"
        }, [_vm.twinType === 'virtualDevice' ? [_vm.mode !== 'create' ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.updateStateText')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.createStateText')) + "\n        ")])] : [_vm.mode !== 'create' ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.updateStateText')) + "\n        ")]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.createStateText')) + "\n        ")])]], 2)];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.copyConfig ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.applyBtnText'),
            "prepend-icon": "fa-paste",
            "data-cy": "apply_config"
          },
          on: {
            "click": function ($event) {
              _vm.openApplyConfigModal = true;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.applyBtnText')) + "\n      ")])] : _vm._e(), _vm.lclModel.id && _vm.wholeFormIsValid ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.buttonText'),
            "prepend-icon": "fa-copy",
            "data-cy": "copy_config"
          },
          on: {
            "click": _vm.copyStateConfig
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.buttonText')) + "\n      ")])] : _vm._e(), _vm.mode !== 'readonly' || _vm.mode === 'readonly' && _vm.stateEditable ? [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.wholeFormIsValid,
            "prepend-icon": "fa-save",
            "data-cy": "save_state_btn"
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n      ")])] : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('core-dtwin-state-apply-copied-config', {
    attrs: {
      "isOpen": _vm.openApplyConfigModal,
      "dtwinId": _vm.lclModel.dtwinId
    },
    on: {
      "close": function ($event) {
        _vm.openApplyConfigModal = false;
      },
      "apply": _vm.doApplyConfig
    }
  }), _c(VForm, {
    ref: "form",
    model: {
      value: _vm.innerFormIsValid,
      callback: function ($$v) {
        _vm.innerFormIsValid = $$v;
      },
      expression: "innerFormIsValid"
    }
  }, [_vm.linkedDeviceError ? _c(VAlert, {
    staticClass: "mb-6 linked-device-error",
    attrs: {
      "type": "error",
      "data-cy": "linked_device_not_found_alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.linkedDeviceError) + "\n    ")]) : _vm._e(), _c(VExpansionPanels, {
    staticClass: "mb-6",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.detailsHeadline')))])]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
      "rules": _vm.requiredRule,
      "required": "",
      "hide-details": "",
      "data-cy": "state_title"
    },
    on: {
      "input": _vm.titleEntered
    },
    model: {
      value: _vm.lclModel.properties.title,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "title", $$v);
      },
      expression: "lclModel.properties.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.titleText')))])], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": "",
      "disabled": !_vm.showNotChangeableKeyPopup
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c('div', _vm._g({}, on), [_c(VTextField, {
          attrs: {
            "disabled": _vm.isKeyFieldDisabled,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.key'),
            "rules": _vm.keyRules,
            "required": "",
            "hide-details": "auto",
            "data-cy": "state_key"
          },
          on: {
            "input": _vm.keyEntered
          },
          model: {
            value: _vm.lclModel.key,
            callback: function ($$v) {
              _vm.$set(_vm.lclModel, "key", $$v);
            },
            expression: "lclModel.key"
          }
        })], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.cannotChangeIdentifier')))])]), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.keyText')))])], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
      "required": "",
      "hide-details": "",
      "data-cy": "state_unit"
    },
    on: {
      "input": function ($event) {
        _vm.manualUnitEdit = true;
      }
    },
    model: {
      value: _vm.lclModel.properties.unit,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "unit", $$v);
      },
      expression: "lclModel.properties.unit"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.unitText')))])], 1), _c(VCol, {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_c('core-icons', {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "faStyle": "solid",
      "dense": true,
      "data-cy": "state_icon"
    },
    model: {
      value: _vm.lclModel.properties.faIcon,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "faIcon", $$v);
      },
      expression: "lclModel.properties.faIcon"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iconText')) + "\n              ")])], 1)], 1), _vm.isGeoState && !_vm.templateContext ? _c(VRow, [_c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.isCreatedByTemplate,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateLinkLabel'),
      "outlined": "",
      "hide-details": "",
      "data-cy": "link_geo_coordinate"
    },
    model: {
      value: _vm.lclModel.properties.linkGeoCoordinate,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "linkGeoCoordinate", $$v);
      },
      expression: "lclModel.properties.linkGeoCoordinate"
    }
  }), _vm.isSingleDimensionGeoState ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateLinkDesc')) + "\n              ")]) : _c('p', {
    staticClass: "card-description mt-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateLinkDescObject'))
    }
  }), _c('p', {
    staticClass: "card-description mt-0 text-bold attention"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateHiddenDesc')) + "\n              ")])], 1), _vm.isSingleDimensionGeoState ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": [{
        value: 'lat',
        text: 'Latitude'
      }, {
        value: 'lon',
        text: 'Longitude'
      }],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": _vm.lclModel.properties.linkGeoCoordinate,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateField'),
      "autocomplete": "off",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.properties.geoCoordinateKey,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "geoCoordinateKey", $$v);
      },
      expression: "lclModel.properties.geoCoordinateKey"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateFieldDesc')) + "\n              ")])], 1) : _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.geoCoordinateIndoorDesc'))
    }
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm.mode !== 'readonly' || _vm.mode === 'readonly' && _vm.isCreatedByTemplate ? _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.source')))])]), _c(VExpansionPanelContent, [_c('core-dtwin-state-edit-source', {
    ref: "sourceEdit",
    attrs: {
      "lclModel": _vm.lclModel,
      "tenantId": _vm.tenantId,
      "mode": _vm.mode,
      "otherStates": _vm.otherStates,
      "dataSources": _vm.dataSources,
      "bridgeConfigs": _vm.bridgeConfigs,
      "twinType": _vm.twinType,
      "twinModel": _vm.twinModel,
      "templateContext": _vm.templateContext,
      "stateDefinition": _vm.stateDefinition,
      "data-cy": 'edit_source'
    },
    on: {
      "changedBindingType": function ($event) {
        return _vm.changedBindingType();
      },
      "bridge-binding-changed": _vm.bridgeBindingChanged,
      "aggregatedStateValue": _vm.aggregatedStateValueChanged,
      "no-permission": _vm.noPermissionError,
      "device-not-found": _vm.deviceNotFoundError,
      "stateUpdated": function ($event) {
        return _vm.$emit('stateUpdated');
      },
      "validate-form": _vm.validateForm
    }
  }), _c('core-dtwin-state-edit-value', {
    ref: "stateValueComp",
    attrs: {
      "templateContext": _vm.templateContext,
      "stateEditable": _vm.stateEditable,
      "lclModel": _vm.lclModel,
      "mode": _vm.mode
    },
    on: {
      "input": _vm.validateForm
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.allowsVisualization ? _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.panelTitle')))])]), _c(VExpansionPanelContent, [_c('core-dtwin-state-edit-visual', {
    ref: "stateVisualComp",
    attrs: {
      "templateContext": _vm.templateContext,
      "value": _vm.lclModel,
      "mode": _vm.mode
    },
    on: {
      "value:updated": _vm.updateLclModel,
      "input": _vm.validateForm
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.shouldRenderOutboundConfigPanel ? _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": 1
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.outboundConfig')))])]), _c(VExpansionPanelContent, [_c('core-dtwin-state-edit-outbound-config', {
    attrs: {
      "connectors": _vm.connectorsWithStateSetting
    },
    model: {
      value: _vm.lclModel,
      callback: function ($$v) {
        _vm.lclModel = $$v;
      },
      expression: "lclModel"
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VExpansionPanels, [_c(VExpansionPanel, {
    on: {
      "change": _vm.onTransformerPanelChange
    }
  }, [_c(VExpansionPanelHeader, {
    attrs: {
      "data-cy": "transformer_header"
    }
  }, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.transformer')))])]), _c(VExpansionPanelContent, [_c('core-dtwin-state-edit-transformer', {
    ref: "stateTransformerComp",
    attrs: {
      "lclModel": _vm.lclModel,
      "twinModel": _vm.twinModel,
      "mode": _vm.mode,
      "templateContext": _vm.templateContext,
      "deviceTemplate": _vm.deviceTemplate,
      "aggregatedStateValue": _vm.aggregatedStateValue
    },
    on: {
      "update:lclModel": _vm.onTransformerUpdate,
      "validatedTransformer": _vm.validateForm
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };